import { AppConstants } from './../../../app.constants';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/layout/main/base.component';

import { Appointment, ItemCode } from 'src/app/api/models/web-booking.models';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent extends BaseComponent implements OnInit {

  appointmentResult: Appointment = new Appointment();
  treatment: ItemCode;
  therapist: any;
  slot: any;
  showAddtoCalendarButton = false;

  ngOnInit() {
    this.initializeLocalStorageItems();
    this.loadExternalScript('https://addevent.com/libs/atc/1.6.1/atc.min.js');
    this.baseTriggerChild.subscribe(event => {
      this.createAddToCalendarLink();
      this.app.spinner.hide();
    });
    this.start();
  }

  initializeLocalStorageItems() {
    this.appointmentResult = JSON.parse(this.app.storageService.getItem(AppConstants.AppointmentResult)) as Appointment;
    if (this.app.stringService.isEmpty(this.appointmentResult)) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    this.treatment = JSON.parse(this.app.storageService.getItem(AppConstants.BookingTreatmentResult)) as ItemCode;
    if (this.app.stringService.isEmpty(this.treatment)) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    this.therapist = JSON.parse(this.app.storageService.getItem(AppConstants.BookingPractionerResult));
    if (this.app.stringService.isEmpty(this.therapist)) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    this.slot = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSlotResult));
    if (this.app.stringService.isEmpty(this.slot)) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
  }

  anotherBooking(): void {    
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
  }

  //#region add to calendar
  public iCalUrl = '';
  public googleUrl = '';
  public outlookUrl = '';
  public outlookOnlineUrl = '';
  public yahooUrl = '';

  createAddToCalendarLink(): void {
    const addToCalendarUrl = 'https://addtocalendar.com/atc/';
    let parameters = '?utz=480' + '&uln=en-US' + '&vjs=1.5';

    parameters = parameters +
      '&e[a][date_start]=' + this.appointmentResult.startTime +
      '&e[a][date_end]=' + this.appointmentResult.endTime +
      '&e[a][timezone]=Australia%2FSydney' +
      '&e[a][title]=Universal Health - ' + this.app.branch.branchName +
      '&e[a][description]=' + '' +
      '&e[a][location]=' + this.app.branch.address +
      '&e[a][organizer]=' + this.app.branch.branchName +
      '&e[a][organizer_email]=' + this.app.branch.email;

    this.iCalUrl = addToCalendarUrl + 'ical' + parameters;
    this.googleUrl = addToCalendarUrl + 'google' + parameters;
    this.outlookUrl = addToCalendarUrl + 'outlook' + parameters;
    this.outlookOnlineUrl = addToCalendarUrl + 'outlookonline' + parameters;
    this.yahooUrl = addToCalendarUrl + 'yahoo' + parameters;    
    this.showAddtoCalendarButton = true;
  }

  loadExternalScript(scriptUrl: string): any {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script')
      scriptElement.src = scriptUrl
      scriptElement.onload = resolve
      document.body.appendChild(scriptElement);
    });
  }
  // #endregion

  //#region Date Manipulation
  getNewDate(inputDate: string): Date {
    const dateTime = inputDate.split('T');
    const dates = dateTime[0].split('-');
    const times = dateTime[1].split(':');

    const year: number = +dates[0];
    const month: number = (+dates[1]);
    const day: number = +dates[2];

    const hour: number = +times[0];
    const minute: number = +times[1];
    const second: number = +times[2];

    return new Date(year, month - 1, day, hour, minute, second);
  }

  formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth()) + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const strMinutes = minutes >= 10 ? minutes : '0' + minutes;
    const strHours = hours >= 10 ? hours : '0' + hours;
    const strMonths = month >= 10 ? month : '0' + month;
    const strDays = day >= 10 ? day : '0' + day;

    const strTime = year + '-' + strMonths + '-' + strDays + 'T' + strHours + ':' + strMinutes + ':00';
    return strTime;
  }
  //#endregion

}

